import { FC } from 'react';
import { ExternalBridge } from './types';
import Icon from '@components/Icon';
import useTransferAssetFlowContext from '@hooks/useTransferAssetFlowContext';
import Tooltip from '@components/Tooltip';

const BridgeCard: FC<ExternalBridge> = ({ name, type, iconSrc, info }) => {
  const { onShowExternalBridgeLink } = useTransferAssetFlowContext();
  return (
    <div className="flex-grow rounded-[5px] h-[120px] flex bg-black justify-center items-center shadow-default ">
      <div className="flex flex-col items-center gap-2.5">
        <div className="flex items-center">
          <img src={iconSrc} alt={name} className="h-[30px] w-auto" />
          {info && <Tooltip message={info} />}
        </div>
        <div
          className="flex items-center gap-0.5 cursor-pointer"
          onClick={() => onShowExternalBridgeLink(type)}
        >
          <div className="text-white">External Link</div>
          <Icon.ExternalLink className="w-[20px] h-[20px]" />
        </div>
      </div>
    </div>
  );
};

export default BridgeCard;
